export const untranslatedRoutes = {
  cloudCostManagement: 'FinOps & GreenOps',
  cloudCostManagementTitle: 'FinOps & GreenOps: Cloud Cost and Carbon Footprint Management',
  infraPolicies: '@:InfraPolicies',
  infraPolicy: '@:InfraPolicy',
  jobs: 'Jobs',
  logs: 'Logs',
  envComponentPipeline: 'Pipeline',
  sandbox: 'Sandbox',
  workers: 'Workers',
  plugin: 'Plugin',
}

export default {
  en: {
    /** Mapped via $route.meta.permissionsKey */
    403: {
      credentials: {
        create: '@:youDoNotHavePermissionsTo create a @:credential',
        details: '@:youDoNotHavePermissionsTo access this @:credential',
      },
      stacks: {
        tools: '@:youDoNotHavePermissionsTo create or maintain a @:project',
      },
      organization: {
        settings: {
          appearance: {
            create: '@:youDoNotHavePermissionsTo create an @:appearance',
            details: '@:youDoNotHavePermissionsTo access this @:appearance',
          },
        },
      },
    },
    projectActivity: '@:Activity',
    apiKey: '@:APIKey',
    apiKeys: '@:APIKeys',
    catalogRepositories: '@:CatalogRepositories',
    catalogRepository: '@:CatalogRepository',
    configRepositories: '@:ConfigRepositories',
    configRepository: '@:ConfigRepository',
    cloudCostManagementDashboard: '@:Dashboard',
    cloudCostManagementProviderDetail: 'In detail',
    cloudCostManagementSection: untranslatedRoutes.cloudCostManagement,
    cloudCostManagementSectionDescription: 'Gain visibility into your cloud expenses and environmental impact with our centralized hub for managing costs and monitoring carbon footprint.',
    cloudCostManagementSettings: 'Settings',
    cloudCostManagementWelcome: 'Welcome',
    credential: '@:Credential',
    credentials: '@:Credentials',
    dashboard: '@:Dashboard',
    dashboardDescription: 'Access your favourite projects and metrics, or keep an eye on recent activity.',
    envComponentConfiguration: 'Configuration',
    envComponentInfrastructure: 'Infrastructure',
    envComponentOverview: 'Overview',
    environment: '@:Environment',
    environmentActivity: '@:Activity',
    environmentComponent: '@:EnvComponent',
    envComponentActivity: '@:Activity',
    envComponentMetrics: '@:Metrics',
    environmentOverview: 'Overview',
    projectOverview: 'Overview',
    events: '@:Events',
    formsEditor: 'StackForms Editor',
    infraTools: 'Tools',
    inventory: '@:Inventory',
    inventoryResource: 'Inventory resource',
    inventoryResourceDetails: 'Inventory resource details',
    inventoryResourceJson: 'Inventory resource JSON',
    login: 'Login',
    noOrgAccess: 'No organization access',
    oidcEjected: 'Access denied',
    marketplaceNewOrganization: 'New @:Organization',
    member: '@:Member',
    members: '@:Members',
    membersInvite: 'Invite @:Members',
    MFAInvalidLoginLink: 'Invalid login link',
    MFALoginLinkNotice: 'Check your email',
    monitoring: 'Monitoring',
    newEnvComponent: 'Create new @:Component',
    notifications: 'Notifications',
    projectConfigElasticSearch: 'Elastic Search logs configuration',
    envComponentConfigInfraView: 'Add Terraform State file configuration',
    observabilitySection: 'Observability',
    observabilitySectionDescription: `Keep an eye on what's happening inside your organization.`,
    cloudAccountSection: 'Cloud Accounts',
    cloudAccountSectionEnvironments: 'Environments',
    cloudAccountSectionSettings: 'Settings',
    orgEnvironmentSection: 'Environments',
    orgEnvironmentSectionOverview: 'Overview',
    orgEnvironmentSectionVariables: 'Variables',
    orgEnvironmentSectionSettings: 'Settings',
    organization: '@:Organization',
    organizations: '@:Organizations',
    orgSettings: 'Settings',
    orgSettingsAppearance: 'Custom @:appearance',
    orgSettingsPlugin: 'Plugin',
    orgSettingsTerraform: '@:externalBackends.RemoteTfBackend',
    orgSettingsPluginOverview: 'Overview',
    orgSettingsPluginVersions: 'Versions',
    orgSettingsPluginWidgets: 'Widgets',
    pipelinesOverview: 'Pipelines Overview',
    privacy: 'Privacy Policy',
    profile: 'Profile',
    profileDescription: 'Update your personal details and preferences.',
    project: '@:Project',
    projectConfiguration: '@:Settings',
    projects: 'All @:Projects',
    projectsSection: '@:Projects',
    resource: '@:Resource',
    resourcesSection: '@:Resources',
    resourcesSectionDescription: 'View, analyze and manage all your resources.',
    role: '@:Role',
    roles: '@:Roles',
    securitySection: 'Security',
    securitySectionDescription: 'Secure your projects and infrastructure, and ensure best practices across your organization.',
    stackOverview: 'Overview',
    stackVersions: 'Versions',
    stackAdoption: 'Adoption',
    stackFromTemplate: 'New @:Stack from blueprint',
    stacks: 'All @:Stacks',
    stacksSection: '@:Stacks',
    stacksSectionDescription: 'Organize your infrastructure-as-code into reusable and configurable stacks, ensuring governance and empowering your teams.',
    status: 'Status',
    team: '@:Team',
    teams: '@:Teams',
    terms: 'Terms of Service',
    userAccount: 'Account',
    userEmails: 'Emails',
    userSecurity: 'Password and authentication',
    userWatchRule: 'Watch rule',
    userNotificationsSettings: 'Notifications settings',
    userWatchRules: 'Watch rules',
    ...untranslatedRoutes,
    beta: {
      resourcesSection: '@:Resources',
      dev: 'Dev pages are always beta',
    },
  },
  es: {
    /** Mapped via $route.meta.permissionsKey */
    403: {
      credentials: {
        create: '@:youDoNotHavePermissionsTo crear una @:credential',
        details: '@:youDoNotHavePermissionsTo acceder a esta @:credential',
      },
      stacks: {
        tools: '@:youDoNotHavePermissionsTo crear o mantener un @:project',
      },
      organization: {
        settings: {
          appearance: {
            create: '@:youDoNotHavePermissionsTo crear una @:appearance',
            details: '@:youDoNotHavePermissionsTo acceder a esta @:appearance',
          },
        },
      },
    },
    projectActivity: '@:Activity',
    apiKey: '@:APIKey',
    apiKeys: '@:APIKeys',
    catalogRepositories: '@:CatalogRepositories',
    catalogRepository: '@:CatalogRepository',
    configRepositories: '@:ConfigRepositories',
    configRepository: '@:ConfigRepository',
    cloudCostManagementDashboard: '@:Dashboard',
    cloudCostManagementProviderDetail: 'En detalles',
    cloudCostManagementSection: untranslatedRoutes.cloudCostManagement,
    cloudCostManagementSectionDescription: 'Obtenga visibilidad sobre sus gastos en la nube y su impacto ambiental con nuestro centro centralizado para la gestión de costos y la huella de carbono.',
    cloudCostManagementSettings: 'Configuración',
    cloudCostManagementWelcome: 'Bienvenido',
    credential: '@:Credential',
    credentials: '@:Credentials',
    dashboard: '@:Dashboard',
    dashboardDescription: 'Acceda a sus proyectos y métricas favoritas, o mantenga un ojo en la actividad reciente.',
    envComponentConfiguration: 'Configuración',
    envComponentInfrastructure: 'Infraestructura',
    envComponentOverview: 'Resumen',
    environment: '@:Environment',
    environmentActivity: '@:Activity',
    environmentComponent: '@:EnvComponent',
    envComponentActivity: '@:Activity',
    envComponentMetrics: '@:Metrics',
    environmentOverview: 'Resumen',
    projectOverview: 'Resumen',
    events: '@:Events',
    formsEditor: 'Editor de StackForms',
    infraTools: 'Herramientas',
    inventory: '@:Inventory',
    inventoryResource: 'Recurso de inventario',
    inventoryResourceDetails: 'Detalles del recurso de inventario',
    inventoryResourceJson: 'Recurso de inventario JSON',
    login: 'Identificación',
    noOrgAccess: 'Sin acceso a la organización',
    oidcEjected: 'Acceso denegado',
    marketplaceNewOrganization: 'Nueva @:Organization',
    member: '@:Member',
    members: '@:Members',
    membersInvite: 'Invitar @:Members',
    MFAInvalidLoginLink: 'Enlace de inicio de sesión no válido',
    MFALoginLinkNotice: 'Revise sus correos electrónicos',
    monitoring: 'Monitoring',
    newEnvComponent: 'Crear nuevo @:Component',
    notifications: 'Notificaciones',
    projectConfigElasticSearch: 'Configuración de los logs de Elastic Search',
    envComponentConfigInfraView: 'Agregar configuración de archivo de estado de Terraform',
    observabilitySection: 'Observabilidad',
    observabilitySectionDescription: `Esté atento a lo que sucede dentro de su organización.`,
    cloudAccountSection: 'Cuentas en la nube',
    cloudAccountSectionEnvironments: 'Entornos',
    cloudAccountSectionSettings: 'Configuraciones',
    orgEnvironmentSection: 'Entornos',
    orgEnvironmentSectionOverview: 'Resumen',
    orgEnvironmentSectionVariables: 'Variables',
    orgEnvironmentSectionSettings: 'Configuraciones',
    organization: '@:Organization',
    organizations: '@:Organizations',
    orgSettings: 'Ajustes',
    orgSettingsAppearance: '@:Appearance personalizada',
    orgSettingsPlugin: 'Plugin',
    orgSettingsTerraform: '@:externalBackends.RemoteTfBackend',
    orgSettingsPluginOverview: 'Resumen',
    orgSettingsPluginVersions: 'Versiones',
    orgSettingsPluginWidgets: 'Widgets',
    pipelinesOverview: 'Resumen de Pipelines',
    privacy: 'Política de Privacidad',
    profile: 'Perfil',
    profileDescription: 'Actualice sus datos personales y preferencias.',
    project: '@:Project',
    projectConfiguration: '@:Settings',
    projects: 'Todo los @:Projects',
    projectsSection: '@:Projects',
    resource: '@:Resource',
    resourcesSection: '@:Resources',
    resourcesSectionDescription: 'Visualiza, analiza y gestiona todos tus recursos.',
    role: '@:Role',
    roles: '@:Roles',
    securitySection: 'Seguridad',
    securitySectionDescription: 'Proteja sus proyectos e infraestructura y garantice las mejores prácticas en toda su organización.',
    stackOverview: 'Resumen',
    stackVersions: 'Versiones',
    stackAdoption: 'Adopción',
    stackFromTemplate: 'Nueva @:Stack de plantilla',
    stacks: 'Todos los @:Stacks',
    stacksSection: '@:Stacks',
    stacksSectionDescription: 'Organice su infraestructura como código en stacks reutilizables y configurables, asegurando el control y empoderando a sus equipos.',
    status: 'Estado',
    team: '@:Team',
    teams: '@:Teams',
    terms: 'Términos de Servicio',
    userAccount: 'Cuenta',
    userEmails: 'Correos electrónicos',
    userSecurity: 'Contraseña y autenticación',
    userWatchRule: 'Regla de monitoreo',
    userNotificationsSettings: 'Configuración de notificaciones',
    userWatchRules: 'Reglas de monitoreo',
    ...untranslatedRoutes,
    beta: {
      resourcesSection: '@:Resources',
      dev: 'Dev pages are always beta',
    },
  },
  fr: {
    /** Mapped via $route.meta.permissionsKey */
    403: {
      credentials: {
        create: '@:youDoNotHavePermissionsTo créer un @:credential',
        details: '@:youDoNotHavePermissionsTo accéder à cet @:credential',
      },
      stacks: {
        tools: '@:youDoNotHavePermissionsTo créer ou maintenir un @:project',
      },
      organization: {
        settings: {
          appearance: {
            create: '@:youDoNotHavePermissionsTo créer une @:appearance',
            details: '@:youDoNotHavePermissionsTo accéder à cet @:appearance',
          },
        },
      },
    },
    projectActivity: '@:Activity',
    apiKey: '@:APIKey',
    apiKeys: '@:APIKeys',
    catalogRepositories: '@:CatalogRepositories',
    catalogRepository: '@:CatalogRepository',
    configRepositories: '@:ConfigRepositories',
    configRepository: '@:ConfigRepository',
    cloudCostManagementDashboard: '@:Dashboard',
    cloudCostManagementProviderDetail: 'En détail',
    cloudCostManagementSection: untranslatedRoutes.cloudCostManagement,
    cloudCostManagementSectionDescription: `Obtenez une visibilité sur vos dépenses liées au cloud et leur impact environnemental grâce à notre centre de gestion centralisé pour les coûts et l'empreinte carbone.`,
    cloudCostManagementSettings: 'Paramètres',
    cloudCostManagementWelcome: 'Bienvenue',
    credential: '@:Credential',
    credentials: '@:Credentials',
    dashboard: '@:Dashboard',
    dashboardDescription: 'Accédez à vos projets et indicateurs préférés, ou gardez un œil sur les récentes activités.',
    envComponentConfiguration: 'Configuration',
    envComponentInfrastructure: 'Infrastructure',
    envComponentOverview: `Vue d'ensemble`,
    environment: '@:Environment',
    environmentActivity: '@:Activity',
    environmentComponent: '@:EnvComponent',
    envComponentActivity: '@:Activity',
    envComponentMetrics: '@:Metrics',
    environmentOverview: `Vue d'ensemble`,
    projectOverview: `Vue d'ensemble`,
    events: '@:Events',
    formsEditor: 'Éditeur StackForms',
    infraTools: 'Outils',
    inventory: '@:Inventory',
    inventoryResource: `Ressource d'inventaire`,
    inventoryResourceDetails: `Détails de la ressource d'inventaire`,
    inventoryResourceJson: `Ressource d'inventaire JSON`,
    login: 'Identification',
    noOrgAccess: 'Aucun accès à l\'organisation',
    oidcEjected: 'Accès refusé',
    marketplaceNewOrganization: 'Nouvelle @:Organization',
    member: '@:Member',
    members: '@:Members',
    membersInvite: 'Inviter des @:Members',
    MFAInvalidLoginLink: 'Lien de connexion invalide',
    MFALoginLinkNotice: 'Vérifiez vos e-mails',
    monitoring: 'Monitoring',
    newEnvComponent: 'Créer un nouveau @:Component',
    notifications: 'Notifications',
    projectConfigElasticSearch: 'Configuration des logs Elastic Search',
    envComponentConfigInfraView: `Ajouter la configuration du fichier d'état Terraform`,
    observabilitySection: 'Observabilité',
    observabilitySectionDescription: `Gardez un œil sur ce qui se passe au sein de votre organisation.`,
    cloudAccountSection: 'Comptes cloud',
    cloudAccountSectionEnvironments: 'Environnements',
    cloudAccountSectionSettings: 'Paramètres',
    orgEnvironmentSection: 'Environnements',
    orgEnvironmentSectionOverview: `Vue d'ensemble`,
    orgEnvironmentSectionVariables: 'Variables',
    orgEnvironmentSectionSettings: 'Paramètres',
    organization: '@:Organization',
    organizations: '@:Organizations',
    orgSettings: 'Réglages',
    orgSettingsAppearance: '@:Appearance personnalisée',
    orgSettingsPlugin: 'Plugin',
    orgSettingsTerraform: '@:externalBackends.RemoteTfBackend',
    orgSettingsPluginOverview: `Vue d'ensemble`,
    orgSettingsPluginVersions: 'Versions',
    orgSettingsPluginWidgets: 'Widgets',
    pipelinesOverview: 'Aperçu des Pipelines',
    privacy: 'Politique de Confidentialité',
    profile: 'Profil',
    profileDescription: 'Mettez à jour vos données personnelles et vos préférences.',
    project: 'Projet',
    projectConfiguration: '@:Settings',
    projects: 'Tous les @:Projects',
    projectsSection: '@:Projects',
    resource: '@:Resource',
    resourcesSection: '@:Resources',
    resourcesSectionDescription: 'Visualisez, analysez et gérez toutes vos ressources.',
    role: '@:Role',
    roles: '@:Roles',
    securitySection: 'Sécurité',
    securitySectionDescription: 'Sécurisez vos projets et votre infrastructure, et assurez les meilleures pratiques dans toute votre organisation.',
    stackOverview: `Vue d'ensemble`,
    stackVersions: 'Versions',
    stackAdoption: 'Adoption',
    stackFromTemplate: `Nouvelle @:Stack à partir d'un modèle`,
    stacks: 'Tous les @:Stacks',
    stacksSection: '@:Stacks',
    stacksSectionDescription: 'Organisez votre infrastructure en tant que code en stacks réutilisables et configurables, garantissant la gouvernance et responsabilisant vos équipes.',
    status: 'Statut',
    team: '@:Team',
    teams: '@:Teams',
    terms: `Conditions d'utilisation`,
    userAccount: 'Compte',
    userEmails: 'E-mails',
    userSecurity: 'Mot de passe et authentification',
    userWatchRule: 'Règle de notifications',
    userNotificationsSettings: 'Paramètres de notifications',
    userWatchRules: 'Règles de notifications',
    ...untranslatedRoutes,
    beta: {
      resourcesSection: '@:Resources',
      dev: 'Dev pages are always beta',
    },
  },
}
